export default "__VITE_ASSET__BIZh21B___"